import React,{createContext, useReducer, useState} from 'react';
import {BrowserRouter,Routes,Route} from 'react-router-dom';
import Home from './components/Home';
import Personal from './components/Personal';
import Projects from './components/Projects';
import Result from './components/Result';
import Skills from './components/Skills';
import Main from './components/Main';
import { initialState, reducer } from './Track';
import './style/app.css';
import Education from './components/Education';
import Objective from './components/Objective';
export const Sabko=createContext();

function App() {
const[state,dispatch]=useReducer(reducer,initialState)  ;
const[Open,setOpen]=useState(true);

const closeMain=()=>{
  setOpen(false)
}

  return (
    <>
    {
      (Open)?(<Main fun={closeMain}/>):(
        <Sabko.Provider value={{state,dispatch}}>
    <BrowserRouter>
    <Routes>
      <Route path='/' element={<Home/>}/>
      <Route path='/personal' element={<Personal/>}/>
      <Route path='/skills' element={<Skills/>}/>
      <Route path='/projects' element={<Projects/>}/>
      <Route path='/result' element={<Result/>}/>
      <Route path='/education' element={<Education/>}/>
      <Route path='/objective' element={<Objective/>}/>
    </Routes>
    </BrowserRouter>
    
   </Sabko.Provider>
      )
    }
   
   </>
  )
}

export default App